<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page026">
<div class="jstfy" id="page026_1">PROVENÇAL PESTO</div>
<div class="jstfy" id="page026_2">TIME REQUIRED:</div>
<div class="jstfy" id="page026_3">T<span class="small">he original recipe</span> for pesto, <span class="page026_3a">pistou</span> in French, consists of only</div>
<div class="jstfy" id="page026_4">10 minutes</div>
<div class="jstfy" id="page026_5">olive oil, fresh basil and garlic.</div>
<div class="jstfy" id="page026_6">100 ml extra-virgin</div>
<div class="jstfy" id="page026_7">1.</div>
<div class="jstfy" id="page026_7a"><span class="page026_7a"> Crush the solid ingredients into a thick paste in a mortar.</span></div>
<div class="jstfy" id="page026_8">2.</div>
<div class="jstfy" id="page026_8a"><span class="page026_8a"> Mix in the oil in a thin stream to make a thick sauce.</span></div>
<div class="jstfy" id="page026_9">olive oil</div>
<div class="jstfy" id="page026_10">3.</div>
<div class="jstfy" id="page026_10a"><span class="page026_10a"> Season with salt.</span></div>
<div class="jstfy" id="page026_11">40 g pine nuts</div>
<div class="jstfy" id="page026_12">1 bunch basil</div>
<div class="jstfy" id="page026_13">5 cloves garlic</div>
<div class="jstfy" id="page026_14">1 tsp yeast flakes</div>
<div class="jstfy" id="page026_15">Salt, pepper</div>
<div class="jstfy" id="page026_16">VINAIGRETTE</div>
<div class="jstfy" id="page026_17">2 tbsp red wine vinegar</div>
<div class="jstfy" id="page026_18">T<span class="small">he word </span><span class="page026_18a">VINAIGRE</span>, the French word for vinegar, literally means</div>
<div class="jstfy" id="page026_19">‘sour wine’. The better the quality of the wine, the better the quality</div>
<div class="jstfy" id="page026_20">7 tbsp olive oil</div>
<div class="jstfy" id="page026_21">of the vinegar.</div>
<div class="jstfy" id="page026_22">1 tsp Dijon mustard</div>
<div class="jstfy" id="page026_23">1 pinch sugar</div>
<div class="jstfy" id="page026_24">1.</div>
<div class="jstfy" id="page026_24a"><span class="page026_24a"> Mix the vinegar with the mustard, sugar, salt and pepper.</span></div>
<div class="jstfy" id="page026_25">1 tsp salt</div>
<div class="jstfy" id="page026_26">2.</div>
<div class="jstfy" id="page026_26a"><span class="page026_26a">Add the oil in a thin stream while whisking with a hand mixer</span></div>
<div class="jstfy" id="page026_27">Pepper</div>
<div class="jstfy" id="page026_28">to give the dressing a creamy consistency.</div>
<div class="jstfy" id="page026_29">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page026_0">26</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_026.vue?6c087ba8